<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big queue" [innerHtml]="'MODAL_2GO_OFFER_MODAL_TITLE' | translate | safeHtml"></div>
    </div>
    <div class="body">
        <div class="section queue-section estimate">
            <div class="section-column">
                <p [innerHtml]="'MODAL_2GO_OFFER_REMAINDER' | translate | safeHtml"></p>
                <p class="estimation" *ngIf='this?.ref?.data?.queue && this.timerFormat && this.timer?.asMilliseconds() > 0'> {{ this.timerFormat }} </p>
                <p class="estimation" *ngIf='this?.ref?.data?.queue && this.timerFormat && this.timer?.asMilliseconds() <= 0'>{{ 'MODAL_2GO_TIMER_OVER' | translate}}</p>
                <button id="modal-size-premium-button-freemium" class="btn-new larger red" [disabled]="(status$ | async) !== 'QueueFinished'"
                    (click)="onUploadAnonymous()" translate>MODAL_2GO_BUTTON_SEND_FILES_FREE</button>
            </div>
        </div>
        <div class="section queue-section insentive">
            <div class="decoration">
                <div class="landscape"></div>
                <div class="rocket" [ngClass]="{'launch': goPremium}"></div>
            </div>
            <div class="section-column">
                <div class="offer" [innerHtml]="'MODAL_2GO_OFFER_TEXT' | translate | safeHtml">
                </div>

                <div class="deal-container">
                    <div class="deal-block">
                        <div class="deal-block-inner">
                            <div class="deal-title" translate>MODAL_2GO_OFFER_TITLE</div>
                            <div class="deal-offer">-52<span>%</span></div>

                        </div>
                        <div class="deal-tag">
                            <div class="tag"></div>
                        </div>
                    </div>
                    <div class="deal-block">
                        <div class="plan"><span class="value">4,80</span><span class="currency">{{currency}}</span><span class="period">/{{
                                'MODAL_2GO_MONTH' | translate }}</span></div>
                    </div>
                </div>
                <div class="deal-footer">
                    <div class="line"></div>
                    <a id="modal-size-premium-link-pricing" class="btn-new larger white cta-special"
                        (click)="goSubscribe($event, 'MODAL_2GO_BUTTON_SUBSCRIBE_LINK' )">
                        {{ 'MODAL_2GO_BUTTON_SUBSCRIBE' | translate }}
                    </a>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div>
</div>